type Props = {
  data: {
    value: number;
    label: string;
  };
};

const BigNumber = ({ data }: Props) => {
  return (
    <div>
      <div className="text-center text-9xl font-semibold text-gray-100">
        {data.value}
      </div>
      <div className="text-center text-xl font-medium text-gray-100">
        {data.label}
      </div>
    </div>
  );
};

export { BigNumber };
